import React, { useState } from "react";
import { useNavigate } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
    Search1Icon,
    UserAppointmentImg1,
    UserAppointmentImg4
} from "../../Constant/Index";
const TherapistAddService = () => {
    const Services = [
        {
            name: "John Merchant",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            image: UserAppointmentImg1
        },
        {
            name: "Couples Psychotherapy",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            image: UserAppointmentImg4
        },
        {
            name: "Couples Psychotherapy",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            image: UserAppointmentImg1
        }
    ];
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/therapist/services');
    }
    const [checkboxStates, setCheckboxStates] = useState({});

    // Function to handle checkbox changes
    const handleCheckboxChange = (checkboxId) => {
        setCheckboxStates((prevState) => ({
            ...prevState,
            [checkboxId]: !prevState[checkboxId] || false,
        }));
    };

    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <form onSubmit={handleSubmit}>
                                    <div className="profile-box">
                                        <div className="top-heading d-flex gap-0 gap-sm-4 align-items-sm-center flex-column flex-sm-row pb-4">
                                            <h3 className="md-heading min-width-fit mb-sm-0">My Offered Service</h3>
                                            <hr className="w-100 my-1 my-sm-3" />
                                            <button className="secondary-btn-2 ms-auto">Add/ Save</button>
                                        </div>
                                        {/* <div className="form-area">
                                        <div className="form-group password">
                                            <input type="text" name="" className="form-control border-0" id="" />
                                            <button className="show-password bg-transparent" type="button">
                                                <img src={Search1Icon} className="eye-icon" alt="" />
                                            </button>
                                        </div>
                                    </div> */}
                                        <div className="appointment-list">
                                            {
                                                Services.map((Service, index) => (

                                                    <div className="single-appointment" key={index}>
                                                        <div className="about-appointment">
                                                            <figure className="appointment-img">
                                                                <img src={Service?.image} alt={Service?.name} className="img-fluid img-here" />
                                                            </figure>
                                                            <div className="appointment-data">
                                                                <span className="name">{Service.name}</span>
                                                                <p className="text">{Service?.para}</p>
                                                            </div>
                                                        </div>
                                                        <div className="time-date" key={index}>
                                                            <input
                                                                type="checkbox"
                                                                name={`addService${index}`}
                                                                className="addcheck"
                                                                id={`add${index}`}
                                                                hidden
                                                                onChange={() => handleCheckboxChange(`checkbox${index}`)}
                                                            />
                                                            <label htmlFor={`add${index}`} className="add-btn cursor-pointer">
                                                                <span className="circle">
                                                                    {/* <i className="fa fa-check" aria-hidden="true"></i> */}
                                                                    <svg width="10" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M1 4.66667L3.75 7.41667L10.1667 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>

                                                                </span>
                                                                {checkboxStates[`checkbox${index}`] ? 'Selected' : 'Select'}
                                                            </label>
                                                        </div>
                                                    </div>

                                                ))
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default TherapistAddService;